import { hasRecoverableMsalLocalState } from "@/services/msalSessionState";

export interface AuthMarkerSyncInput {
    isAuthenticated: boolean;
    isLoading: boolean;
    isProcessingRedirect: boolean;
    loginType: "msal" | "external" | null;
}

export const AUTH_MARKER_KEY = "app_auth_state";

export function hasRecoverableAuthStorageHints(storage: Storage): boolean {
    if (storage.getItem("externalUserProfile")) {
        return true;
    }

    return hasRecoverableMsalLocalState(storage);
}

export function syncAuthStateMarker(
    storage: Storage,
    input: AuthMarkerSyncInput,
    now: number = Date.now()
): "set" | "remove" | "noop" {
    const { isAuthenticated, isLoading, isProcessingRedirect, loginType } =
        input;

    // Avoid destructive marker updates while auth bootstrap/redirect is in progress.
    if (isLoading || isProcessingRedirect) {
        return "noop";
    }

    if (isAuthenticated) {
        storage.setItem(
            AUTH_MARKER_KEY,
            JSON.stringify({
                timestamp: now,
                authenticated: true,
                loginType,
            })
        );
        return "set";
    }

    // Do not remove marker if this tab is still carrying recoverable auth hints.
    // A freshly opened tab may transiently be unauthenticated before session restoration.
    if (!hasRecoverableAuthStorageHints(storage)) {
        storage.removeItem(AUTH_MARKER_KEY);
        return "remove";
    }

    return "noop";
}
